import * as React from 'react';
import { Icon } from '@teamsnap/snap-ui';

interface NoticeType {
  title?: string;
  subtitle?: string | React.ReactNode;
  sentiment: 'warning' | 'info';
  className?: string;
}

export const Notice = ({ title, subtitle, sentiment, className }: NoticeType) => {
  let containerBgClass = '';
  let textColorClass = '';

  if (sentiment === 'warning') {
    containerBgClass = 'sui-bg-yellow-80';
    textColorClass = 'sui-text-yellow-30';
  }

  if (sentiment === 'info') {
    containerBgClass = 'sui-bg-skyblue-90';
    textColorClass = 'sui-text-skyblue-30';
  }

  return (
    <div
      data-testid="notice--container"
      className={`sui-flex sui-items-center sui-p-1 sui-pr-2 ${containerBgClass} sui-rounded ${className}`}
    >
      <div data-testid="notice--icon-container" className={'sui-mr-1 sui-p-1 sui-grid sui-place-items-center'}>
        <Icon name={sentiment} size="l" className={textColorClass} />
      </div>

      <div data-testid="notice--content" className="sui-flex-1">
        <div data-testid="notice--content-title" className={`${textColorClass} sui-heading-sm sui-font-normal sui-mb-0.5`}>
          {title}
        </div>
        <div data-testid="notice--content-subtitle" className={`${textColorClass} sui-caption`}>
          {subtitle}
        </div>
      </div>
    </div>
  );
};

Notice.defaultProps = {
  title: '',
  subtitle: '',
};
